import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'synfrastructure';

class CheckboxBoolean extends Component {
  static propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.oneOf(['']), PropTypes.bool]),
    onChange: PropTypes.func,
  };

  onChange = () => {
    this.props.onChange(!this.props.value);
  };

  render() {
    return (
      <Checkbox
        id={this.props.id || this.props.label || 'checkbox'}
        value={true}
        checked={!!this.props.value}
        onChange={this.onChange}
      />
    );
  }
}

export default CheckboxBoolean;



// WEBPACK FOOTER //
// ./src/common/forms/CheckboxBoolean.js